module.exports = __webpack_public_path__ + "media/images/produtos-e-marcas-3-01bc13b0aa4736ec738292deb94c152b.jpg";